<script>
import { warehouseOrderInfoList } from "@/lib/request";
export default {
  name: 'channelConsume',
  data(){
    return {
      activeTab: '',
      orderId: '',
      // 列表数据
      page1: 1,//当前页
      size1: 20,//每页条数
      totals1: 0,//总条数
      totalPages1: 0,//总页数
      finished1: true,
      loading1: false,
      finishedMsgTxt: '没有更多了',
      orderList: []
    }
  },
  watch: {
    // 监控参数变化
    listParams: function () {
      if (this.siteId && this.siteId.length >= 8) {
        this.getList();
      } else {
        if (this.siteId > 1) {
        } else {
          this.getList();
        }
      }
    },
  },
  computed: {
    // 监控参数变化更新
    listParams() {
      return {
        wh_id: this.activeTab === '1' ? '' : 'ck-000',//DB?'ck-000':''
        targetWhId: this.activeTab === '1' ? 'ck-000' : '',//RK?'ck-000':''
        pageSize: this.size1,//每页数量
        pageNum: this.page1,//当前页码
        transferOrderId: this.orderId ? this.orderId : this.activeTab === '1' ? 'RK' : 'DB',//
        orderByColumn:'createTime',
        isAsc:'desc',//desc:降序，asc：升序
      };
    },
  },
  methods: {
    onLoad() {
      setTimeout(() => {
        if (this.page1 < this.totalPages1) {
          this.page1 = this.page1 + 1;
        }
      }, 1000);
    },
    getList() {
      this.loading1 = true;
      this.finished1 = false;
      if (this.listParams.pageNum === 1) {
        this.orderList = [];
      }
      warehouseOrderInfoList(this.listParams).then((res) => {
        if (res) {
          if (!res.data) {
            return;
          }
          if (res.data) {
            this.loading1 = false;
            if (res.data.code === 200) {
              this.totals1 = res.data.total;
              this.totalPages1 = Math.ceil(res.data.total / this.size1);
              if (res.data.rows == null || res.data.rows.length === 0) {
                this.finished1 = true;
                this.orderList = [];
                return false;
              } else {
                if (this.page1 > 1) {
                  this.orderList = this.orderList.concat(res.data.rows);
                } else {
                  this.orderList = res.data.rows;
                }
                // 总条数和每页条数
                if (this.totals1 < this.size1) {
                  this.finished1 = true;
                  return;
                }
                // 当前页和总页数
                if (this.page1 === this.totalPages1) {
                  this.finished1 = true;
                  return false;
                }
              }
            } else {
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    }
  },
  created() {
    if (this.$route.query.type) {
      this.activeTab = this.$route.query.type;
    }
  }
}
</script>

<template>
  <div class="content-inn">
    <div class="tabs">
      <van-tabs v-model="activeTab" animated swipeable sticky>
        <van-tab title="入库记录" name="1"></van-tab>
        <van-tab title="调拨记录" name="2"></van-tab>
      </van-tabs>
    </div>
    <div class="nav-search">
      <input type="number" v-model="orderId" placeholder="搜索订单编号"/>
      <button class="button" @click="orderId=''">重置</button>
    </div>
    <div class="tab-content">
      <div class="record-content">
        <!-- 列表 -->
        <div class="application-content">
          <van-list v-model="loading1" :finished="finished1" :finished-text="finishedMsgTxt" :immediate-check="false"
                    @load="onLoad">
            <div class="application-item" v-for="(item,index) in orderList" :key="index">
              <div class="application-info-wrapper">
                <div class="application-header">
                  <span
                      class="application-id">{{ activeTab === '1' ? '入库' : '调拨' }}编号: {{ item.transferOrderId }}</span>
                </div>
                <div class="application-details">
                  <div class="detail-item" v-if="activeTab==='2'">
                    <span class="box-detail-label">目标仓库：</span>
                    <span class="detail-value network-code">{{ item.warehouseName }}</span>
                  </div>
                  <div class="detail-item">
                    <span class="box-detail-label">{{ activeTab === '1' ? '入库' : '调拨' }}数量：</span>
                    <span class="detail-value quantity-highlight">{{ item.boxNumber }}箱</span>
                  </div>
                  <div class="detail-item">
                    <span class="box-detail-label">{{ activeTab === '1' ? '入库' : '调拨' }}时间：</span>
                    <span class="detail-value">{{ item.createTime }}</span>
                  </div>
                  <div class="detail-item">
                    <span class="box-detail-label">操作员：</span>
                    <span class="detail-value">{{ item.nickName }}</span>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.content-inn {
  padding-top: 90px;
}

.inner-firm {
  display: flex;
  width: 100%;
  height: auto;
  padding: 20px;
  flex-direction: column;

  .modal-title-info {
    text-align: center;
    font-size: 36px;
    padding: 20px;
    font-weight: 600;
    color: #2d3436;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .modal-content-info {
    display: flex;
    flex-direction: column;

    .modal-detail-info {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 10px 20px;

      .modal-detail-label {
        color: #6c757d
      }

      .modal-detail-value {
        color: #2d3436;
        font-weight: 600;
      }
    }
  }
}

.tab-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 120px;

  .stats-cards {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 20px;

    .stat-card {
      flex: 1;
      background: white;
      padding: 20px 15px;
      margin: 0 15px;
      border-radius: 10px;
      text-align: center;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    }
  }

}

.nav-search {
  display: flex;
  flex-direction: row;
  padding: 0 30px 10px;

  input {
    width: 78%;
    height: 80px;
    outline: none;
    padding: 0 20px;
    box-sizing: border-box;
    border-radius: 5px;
    border: 2px solid #ddd;
    margin-right: 2%;
  }

  .button {
    width: 20%;
    border-radius: 5px;
    height: 78px;
    font-size: 28px;
    background: #e62d2d;
    color: #fff;
    border: none;
  }
}

.prediction-notice {
  background: linear-gradient(135deg, #00b894 0%, #00a085 100%);
  color: white;
  padding: 20px 20px;
  text-align: center;
  font-size: 28px;
  font-weight: 500;
  border-bottom: 1px solid #e9ecef;
}

.van-cell {
  border: 2px solid #e9ecef;
  border-radius: 10px;
}

.form-section {
  padding: 20px;
}

.warehouse-label {
  font-size: 28px;
  color: #495057;
  margin-bottom: 8px;
  font-weight: 500;
}

.modal-options {
  padding: 0 30px;
  display: flex;
  flex-wrap: wrap;
}

.modal-option {
  background-color: #f5f5f5;
  border-radius: 35px;
  padding: 5px 35px;
  margin-right: 25px;
  margin-bottom: 20px;
  color: #666;
  border: 2px solid #8f8f8f;
}

.active {
  background-color: #e62d2d;
  border: 2px solid #e62d2d;
  color: white;
}


.supply-item {
  background: white;
  //border: 2px solid #e17055;
  border-radius: 12px;
  margin-bottom: 15px;
  overflow: hidden;
  transition: all 0.3s ease;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.supply-item:hover {
  border-color: #e17055;
  box-shadow: 0 4px 12px rgba(225, 112, 85, 0.1);
}

.supply-header {
  padding: 30px 20px;
  //background: linear-gradient(135deg, #fff5f3 0%, #fef5f3 100%);
}

.supply-name {
  font-size: 38px;
  font-weight: 600;
  color: #2d3436;
  margin-bottom: 10px;
}

.supply-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;

}

.quantity-section {
  background: white;
  padding: 0 20px;
  //border-top: 1px solid #f1f3f4;
}

.quantity-input {
  display: flex;
  flex-direction: column;
  //align-items: center;
  margin-bottom: 25px;
}

.quantity-label {
  font-size: 28px;
  color: #495057;
  margin-right: 15px;
  margin-bottom: 25px;
  min-width: 80px;
  font-weight: 500;
}

.quantity-controls {
  display: flex;
  width: 100%;
  //align-items: center;
  //border: 2px solid #e9ecef;
  //border-radius: 10px;
  //overflow: hidden;
  //opacity: 0.5;
}

.quantity-btn {
  background: #e62d2d;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: not-allowed;
  padding: 20px 40px;
  margin: 10px 20px;
  color: #fff;
  font-weight: 600;
  border-radius: 10px;
}

.quantity-input input {
  border: none;
  width: 170px;
  height: 45px;
  text-align: center;
  background: #f8f9fa;
  font-weight: 600;
  color: #6c757d;
  cursor: not-allowed;
}

.application-content {
  padding: 20px;
}

.application-item {
  background: white;
  border-radius: 12px;
  padding: 28px;
  margin-bottom: 15px;
  //border-left: 4px solid #00b894;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  display: flex;
  justify-content: space-between;
  //align-items: center;
}

.application-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

/* --- ADDED --- */
.application-info-wrapper {
  margin-right: 15px;
}

.application-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px; /* MODIFIED */
}

.application-id {
  font-size: 28px;
  color: #495057;
  font-weight: 600;
}

.application-details {
  /* --- MODIFICATION START --- */
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 8px 20px; /* row-gap column-gap */
  /* --- MODIFICATION END --- */
  color: #6c757d;
  line-height: 1.6;
  margin-bottom: 0; /* MODIFIED */
}

.detail-item {
  display: flex;
  /* --- REMOVED justify-content: space-between; --- */
  gap: 5px; /* ADDED */
}

.box-detail-label {
  color: #6c757d;
}

.detail-value {
  color: #2d3436;
  font-weight: 600;
}

.quantity-highlight {
  color: #e17055;
  font-weight: 700;
  font-size: 28px;
}

.network-code {
  color: #0984e3;
  font-family: 'Monaco', 'Consolas', monospace;
}

.action-buttons {
  text-align: right;
  flex-shrink: 0;
}

.record-time {
  color: #6c757d;
  background: #f8f9fa;
  padding: 8px 20px;
  border-radius: 22px;
}

.action-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.outbound-btn {
  background: linear-gradient(135deg, #e17055 0%, #d63031 100%);
  color: white;
}

.outbound-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(225, 112, 85, 0.3);
}

.outbound-btn:disabled {
  background: #bbb;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.group-video {
  border: 1px dashed #afafaf;
  border-radius: 10px;
  height: 37vw;
  width: 37vw;
  margin-top: 20px;
  margin-bottom: 20px;
  position: relative;

  .group-video-load {
    position: relative;
    border-radius: 10px;
    height: 100%;
    width: 100%;
    border: 1px dashed #e9e9e9;
    overflow: hidden;

    .avatar-uploader {
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      .el-upload {
        width: 100%;
        height: 100%;

        .avatar {
          width: 100%;
          height: 100%;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .group-load-item {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 1;
      transform: translate(-50%, -50%);
      border-radius: 10px;
      padding: 70px 0;
      text-align: center;
      width: 100%;
      height: 100%;
      font-size: 28px;

      .video-icon-img {
        width: 80px;
        height: 50px;
        margin: 0 auto;
        font-size: 60px;
        color: #ababab;

        img {
          width: 80px;
          height: 50px;
        }
      }

      .video-icon-txt {
        color: #ababab;
        padding-top: 20px;
      }
    }

    .aod {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 10000;
      color: #fff;
      font-size: 30px;
      height: 44px;
      line-height: 44px;
      width: 44px;
      text-align: center;
      background: #222;
      border-radius: 0 12px 0 0.32rem;
    }
  }
}
</style>